// extracted by mini-css-extract-plugin
export var discard = "_2i-4";
export var muiTooltipTooltip = "_2i-6";
export var notificationBar = "_2i-3";
export var notificationContainer = "_2i-2";
export var saveButtonHoverSlotWrapper = "_2i-5";
export var show = "_2i-1";
export var spacer = "_2i-0";